
import React from 'react';

const ButtonJoinChat = ({ isDisabled = false, onJoinChat = null }) => (
  <button className="btn btn-bright btn-md2 mr10" type="button" disabled={isDisabled} onClick={onJoinChat && onJoinChat()}>Join chat</button>
);

export default ButtonJoinChat;
